import axios from 'axios';

export default async (
  restaurantId: string,
  paymentMode: boolean,
  urlSearchParams: URLSearchParams
): Promise<{ clientId: string }> => {
  const path = paymentMode
    ? `/v2/restaurants/${restaurantId}/payment/table-status`
    : `/v2/restaurants/${restaurantId}/table-status`;
  const { data } = await axios.get(
    `${window.AZZURRI_ENV.apiEndpoint}${path}?${urlSearchParams.toString()}`
  );
  return data;
};
